import { useState, useEffect } from 'react';
import { Film, Users, PlayCircle, Activity } from 'lucide-react';

const API_URL = import.meta.env.VITE_API_URL || 'https://heritage-os-api.uplaytv3117.workers.dev/api/v1';

export default function DashboardHome() {
  const [stats, setStats] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const token = localStorage.getItem('jwt_token');
        const res = await fetch(`${API_URL}/analytics/stats`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (res.ok) {
          const data = await res.json();
          if (data && data.length > 0) {
            setStats(data[0]);
          }
        }
      } catch (err) {
        console.error('Failed to fetch stats:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  return (
    <div className="p-6 max-w-6xl mx-auto space-y-8">
      <div className="flex flex-col items-start gap-2">
        <h1 className="text-2xl font-semibold text-slate-900">Dashboard</h1>
        <p className="text-slate-500 text-sm">Welcome back to HeritageOS. Here is what's happening.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-sm font-medium text-slate-500">Total VOD Stories</h3>
            <Film className="w-5 h-5 text-indigo-500" />
          </div>
          <p className="text-3xl font-semibold text-slate-900">
            {loading ? '...' : stats?.total_stories || 0}
          </p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-sm font-medium text-slate-500">Total Users</h3>
            <Users className="w-5 h-5 text-blue-500" />
          </div>
          <p className="text-3xl font-semibold text-slate-900">
            {loading ? '...' : stats?.total_users || 0}
          </p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-sm font-medium text-slate-500">Total Views</h3>
            <PlayCircle className="w-5 h-5 text-emerald-500" />
          </div>
          <p className="text-3xl font-semibold text-slate-900">
            {loading ? '...' : stats?.total_views || 0}
          </p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-sm font-medium text-slate-500">Completion Rate</h3>
            <Activity className="w-5 h-5 text-purple-500" />
          </div>
          <p className="text-3xl font-semibold text-slate-900">
            {loading ? '...' : `${(stats?.completion_rate || 0).toFixed(1)}%`}
          </p>
        </div>
      </div>
    </div>
  );
}
